module.exports = __webpack_public_path__ + "static/hero-text-553cc3c22378f3b7c64ddc3b77c9be31.png";